import Vue from "vue";
import moment from "moment";

Vue.filter("bindPath", value => {
  // bind spring filestroe.save_root path.
  if (!value) {
    return "";
  }

  const root_path = process.env.VUE_APP_API_HOST.endsWith("/")
    ? process.env.VUE_APP_API_HOST
    : process.env.VUE_APP_API_HOST + "/";

  const value_path = value.startsWith("/") ? value : "/" + value;
  return root_path + "Path" + value_path;
});

Vue.filter("bindPublicPath", value => {
  // bind public assets folder path.
  if (!value) {
    return "";
  }
  return Vue.prototype.$publicPath + value;
});

Vue.filter("bindCDNPath", value => {
  // bind spring filestroe.save_root path or cdn
  if (!value) {
    return "";
  }
  return process.env.VUE_APP_CDN_PATH + value;
});

Vue.filter("dateFormat", (value, format) => {
  // dateFormat
  if (!value) {
    return "";
  }

  const _format = format || "YYYY-MM-DD HH:mm:ss";
  return moment(value).format(_format);
});
